import React from "react";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { useLocale } from "../i18n/useLocale";
import DottedHongKong from "../components/DottedHongKong";

const Hero = () => {
  const { t } = useTranslation();
  const { path } = useLocale();

  return (
    <section id="home" className="hero">
      <div className="wrap hero-grid">
        <div className="hero-copy">
          <h1>
            <Trans i18nKey="home.title" components={{ with: <span className="slogan-with" /> }} />
          </h1>
          <p className="hero-lead">{t("home.lead")}</p>
          <Link className="link-go" to={path("/solutions")}>
            {t("home.seeSolutions")}
          </Link>
          <a className="hero-next" href="#work">
            <span aria-hidden="true">↓</span>
            <span className="vh">{t("home.whereWork")}</span>
          </a>
          <DottedHongKong label={t("home.hongKong")} />
        </div>
      </div>
    </section>
  );
};

export default Hero;
